module.exports = __webpack_public_path__ + "img/Multiview - Blue.fbe83dcb.png";